import { createContext } from 'react';

import { DataManagerContextValue } from './DataManagerContext.types';

export const DataManagerContext = createContext<DataManagerContextValue>({
  chosenAttributeId: null,
  setChosenAttributeId: () => false,
  onDoubleClick: () => false,
});
